<template>
  <a-layout>
    <a-card :bordered='false'>
      <a-button size='small' @click="()=>{$router.go(-1)}">
        <LeftOutlined />返回
      </a-button>
      <span class="ml15 card_title">{{$route.query.type == 'add' ? '创建':'编辑'}}签约任务</span>
    </a-card>
    <a-card :bordered="false">
      <a-steps v-model:current="current" type="navigation" size="small" :style="{
            marginBottom: '20px',
            boxShadow: '0px -1px 0 0 #e8e8e8 inset',
          }">
      <a-step :status="current==0?'process':'wait'" :disabled="$route.query.type!='edit'" title="基本信息" />
        <a-step :status="current==1?'process':'wait'" :disabled="$route.query.type!='edit'" title="参与范围" />
      </a-steps>
      <div class="content" v-show="current == 0">
        <setpsOne ref="one" v-on:setpsOneDone="setpsOneDone" :id="$route.query.id||id" :isAction="isAction"  />
      </div>
      <div class="content" v-if="current == 1">
        <setpsTwo ref="two" :id="id" v-on:setpsTwoProvide="setpsTwoProvide" v-on:setpsTwoNext="setpsTwoNext" :actionType='$route.query.type' />
      </div>
    </a-card>
  </a-layout>
</template>
<script>
import { ref } from "@vue/reactivity";
import setpsOne from "./components/setpsOne";
import setpsTwo from "./components/setpsTwo";
import { inject, onMounted } from "@vue/runtime-core";
import { LeftOutlined} from "@ant-design/icons-vue";
export default {
  components: { setpsOne, setpsTwo,LeftOutlined, },
  setup() {
    const $route = inject("$route");
    const current = ref(0);
    const id=ref('')
      const two=ref()
    const isAction = ref(false)
    // 下一步
    const setpsOneDone = (data) => { 
      console.log(data);
      if ($route.query.id) {
        id.value=$route.query.id
      }else if(data.id){
         id.value=data.id
      }
      console.log(id.value);
      current.value++
      setpsTwoDetail();
      isAction.value=true;
    };
     // 第一步结束
    // 第二步开始
    var setpsTwoDetail=()=>{
      two.value && two.value.detail();
    }
     // 第二步 下一步
    const setpsTwoNext=()=>{
      //  current.value++;
    };
    // 获取详情
    const one = ref("");
    const setpsOneDetail = () => {
      one.value.detail();
    };
    //第二步上一步
    const setpsTwoProvide=()=>{
      setpsOneDetail();
      current.value--
    };
    onMounted(() => {
      if ($route.query.id) {
        id.value=$route.query.id
        setpsOneDetail();
      }
    });
    return {
      current,
      setpsOneDone,
      one,
      id,
      setpsTwoProvide,
      setpsTwoNext,
      two,
      isAction
    };
  },
};
</script>